export const queryKeys = {
  aircraft: {
    all: () => ["Aircraft"] as const,
    list: (orgId: string) => ["Aircraft", "List", orgId] as const,
    listWithHidden: (orgId: string) => ["Aircraft", "List", orgId, "WithHidden"] as const,
    details: () => ["Aircraft", "Detail"] as const,
    detail: (id: string) => ["Aircraft", "Detail", id] as const,
    generalInfo: (id: string) => ["Aircraft", "Detail", id, "GeneralInfo"] as const,
    ownership: (id: string) => ["Aircraft", "Detail", id, "Ownership"] as const,
    specs: (id: string) => ["Aircraft", "Detail", id, "Specs"] as const,
    equipment: (id: string) => ["Aircraft", "Detail", id, "Equipment"] as const,
    activityCard: (id: string, source: string) =>
      ["Aircraft", "Detail", id, "Activity", "Card", source] as const,
    activityPage: (id: string, filters: Record<string, unknown>) =>
      ["Aircraft", "Detail", id, "Activity", "Page", filters] as const,
    ownerPreferences: (id: string) =>
      ["Aircraft", "Detail", id, "OwnerPreferences"] as const,
    name: (id: string) => ["Aircraft", "Detail", id, "Name"] as const,
    documents: (id: string, source: string) =>
      ["Aircraft", "Detail", id, "Documents", source] as const,
    categories: () => ["Aircraft", "Categories"] as const,
  },
  documents: {
    categories: (orgId: string) => ["Documents", "Categories", orgId] as const,
  },
  crew: {
    all: () => ["Crew"] as const,
    list: (orgId: string) => ["Crew", "List", orgId] as const,
    select: (orgId: string) => ["Crew", "Select", orgId] as const,
  },
  operators: {
    all: () => ["Operators"] as const,
    list: (orgId: string) => ["Operators", "List", orgId] as const,
    select: (orgId: string) => ["Operators", "Select", orgId] as const,
  },
  owners: {
    all: () => ["Owners"] as const,
    list: (orgId: string) => ["Owners", "List", orgId] as const,
    select: (orgId: string) => ["Owners", "Select", orgId] as const,
  },
  users: {
    all: () => ["Users"] as const,
    list: (orgId: string) => ["Users", "List", orgId] as const,
    orgMembers: (orgId: string) => ["Users", "OrgMembers", orgId] as const,
  },
  search: {
    results: (orgId: string, term: string) => ["Search", orgId, term] as const,
  },
  airports: {
    all: () => ["Airports"] as const,
    search: (term: string) => ["Airports", "Search", term] as const,
  },
  leon: {
    integration: (orgId: string) => ["Leon", "Integration", orgId] as const,
    synclock: (orgId: string) => ["Leon", "SyncLock", orgId] as const,
    events: (orgId: string) => ["Leon", "Events", orgId] as const,
    liveLog: (orgId: string) => ["Leon", "LiveLog", orgId] as const,
    progress: (orgId: string) => ["Leon", "Progress", orgId] as const,
  },
  flights: {
    all: () => ["Flights"] as const,
    paginated: (filters: Record<string, unknown>) =>
      ["Flights", "Paginated", filters] as const,
    summary: (filters: Record<string, unknown>) =>
      ["Flights", "Summary", filters] as const,
    analytics: (aircraftId: string, dateKey: string) =>
      ["Flights", "Analytics", aircraftId, dateKey] as const,
  },
  invoices: {
    all: () => ["Invoices"] as const,
    allMonthSummaries: () => ["Invoices", "MonthSummaries"] as const,
    monthSummaries: (orgId: string, aircraftId: string | undefined, year: number) =>
      ["Invoices", "MonthSummaries", orgId, aircraftId ?? "all", year] as const,
    uploads: (orgId: string) => ["Invoices", "Uploads", orgId] as const,
    categories: (orgId: string) => ["Invoices", "Categories", orgId] as const,
    lateLists: () => ["Invoices", "LateList"] as const,
    lateList: (orgId: string, aircraftId: string | undefined, year: number) =>
      ["Invoices", "LateList", orgId, aircraftId ?? "all", year] as const,
    monthInboxes: () => ["Invoices", "MonthInbox"] as const,
    monthInbox: (
      orgId: string,
      aircraftId: string | undefined,
      year: number,
      month: number,
      lateOnly: boolean,
    ) =>
      [
        "Invoices",
        "MonthInbox",
        orgId,
        aircraftId ?? "all",
        year,
        month,
        lateOnly ? "late" : "all",
      ] as const,
    allLegCodes: () => ["Invoices", "LegCodes"] as const,
    legCodes: (orgId: string, aircraftId: string | null, year: number, month: number) =>
      ["Invoices", "LegCodes", orgId, aircraftId ?? "all", year, month] as const,
  },
  llm: {
    configurations: (orgId: string) => ["Llm", "Configurations", orgId] as const,
  },
  presets: {
    user: (userId: string) => ["Presets", "User", userId] as const,
  },
  test: () => ["Test"] as const,
}

// A correction (vendor, category, leg code) shows in the inbox, the late list and the review count
export const invoiceCorrectionKeys = () => [
  queryKeys.invoices.monthInboxes(),
  queryKeys.invoices.lateLists(),
  queryKeys.invoices.allMonthSummaries(),
]
